export interface AccessCodeRecordInterface {
  id: string;
  code: string;
  subscriptionDuration: number;
  subscriptionPlan: number;
  userId: string;
  expirationDate?: string;
  target?: string;
  usedDate?: string;
  fullName?: string;
  email?: string;
  createdAt: string;
  firstName?: string;
  lastName?: string;
  status: AccessCodeStatus;
}

export enum SubscriptionPlan {
  CHAMPION = 'CHAMPION',
  LEGEND = 'LEGEND',
  FREE = 'FREE',
}

export enum SubscriptionDuration {
  MONTHLY = 'MONTHLY',
  YEARLY = 'YEARLY',
}

export enum StageFormAccessCode {
  NONE = 0,
  ONLY = 1,
  MULTI = 2,
}

export enum SubscriptionPlanValue {
  CHAMPION = 1,
  LEGEND = 2,
  RANDOM = 3,
  ALL = 0,
}

export enum SubscriptionDurationValue {
  RANDOM = 0,
  MONTHLY = 1,
  YEARLY = 2,
  INPUT = 3,
  ALL = 4,
}

export enum InputDuration {
  INPUT = 1,
  NOT_INPUT = 0,
}

export interface SubscriptionFormGenerateOnly {
  subscriptionPlan: number;
  subscriptionDuration: number;
}

export interface SubscriptionFormGenerateMulti {
  quantity: number;
  subscriptionDuration: number;
  subscriptionPlan: number;
  inputDuration?: number;
  target?: string;
}

export interface SubscriptionFormExportToCsv {
  subscriptionPlan: number;
}

export enum AccessCodeStatus {
  AVAILABLE = 'AVAILABLE',
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
  INACTIVE_BY_UPGRADE = 'INACTIVE_BY_UPGRADE',
  EXPIRED = 'EXPIRED',
  ALL = 'ALL',
}
